import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateOfBirthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const invalidDateError = { invalidDate: true };
    let date: Date;

    // Handle both Date objects from mat-datepicker and strings
    if (control.value instanceof Date) {
      date = control.value;
    } else {
      const dateString = control.value.toString().trim();
      const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      const match = dateString.match(dateRegex);

      if (!match) {
        return invalidDateError;
      }

      const [, monthStr, dayStr, yearStr] = match;
      const month = parseInt(monthStr, 10);
      const day = parseInt(dayStr, 10);
      const year = parseInt(yearStr, 10);

      // Basic range checks for string input
      if (month < 1 || month > 12 || day < 1 || day > 31) {
        return invalidDateError;
      }

      date = new Date(year, month - 1, day);
    }

    // Validate the date object
    if (isNaN(date.getTime())) {
      return invalidDateError;
    }

    // Check if date is not in the future
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (date > today) {
      return invalidDateError;
    }

    // check if age is over 130 years
    const currentYear = new Date().getFullYear();
    const age = currentYear - date.getFullYear();
    if (age > 130) {
      return invalidDateError;
    }

    return null;
  };
}
